function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { sync } from 'vuex-pathify';

var ProgressBar = /*#__PURE__*/function () {
  function ProgressBar() {
    _classCallCheck(this, ProgressBar);
  }

  _createClass(ProgressBar, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-progessbar', {
        template: "\n      <div class=\"wrapper\" v-show=\"!step.hidden && !step.hiddenOnShow\">\n        <div class=\"mobile\">\n            <button class=\"prev\" @click=\"prev\" :class=\"{hide:currentStep === 0}\"></button>\n            <span class=\"progress\">{{step.number | padZero}}/{{maxCount | padZero}}</span> <span class=\"title\">{{step.name}}</span>\n        </div>\n        <a v-for=\"(stepItem, index) of steps\" :class=\"{'is-active':(index==currentStep),'is-disabled':(index>currentStep)}\" @click=\"setStep(index)\" v-if=\"!stepItem.hidden\">\n          <span>{{stepItem.name}}</span>\n        </a>\n      </div>",
        computed: {
          steps: sync('forms/steps'),
          currentStep: sync('forms/currentStep'),
          step: function step() {
            return this.steps[this.currentStep] || {};
          },
          maxCount: function maxCount() {
            return Math.max.apply(Math, _toConsumableArray(this.steps.map(function (s) {
              return s.number;
            })));
          }
        },
        mounted: function mounted() {
          this.moveFeedbackWidget();
        },
        watch: {
          currentStep: function currentStep() {
            this.moveFeedbackWidget();
          }
        },
        methods: {
          setStep: function setStep(index) {
            if (index > this.currentStep) {
              return;
            }

            this.currentStep = index;
          },
          next: function next() {
            if (this.currentStep <= this.maxCount) {
              this.currentStep++;
            }
          },
          prev: function prev() {
            if (this.currentStep !== 0) {
              this.currentStep--;
            }
          },
          moveFeedbackWidget: function moveFeedbackWidget() {
            var progressBarHeight = 60;
            var defaultWidgetOffset = 20;
            var feedbackWidget = document.querySelector('.gf-Bobblehead-wrapper');

            if (!feedbackWidget) {
              return;
            }

            if (this.step.hidden || this.step.hiddenOnShow) {
              feedbackWidget.style.bottom = "".concat(defaultWidgetOffset, "px");
              return;
            }

            feedbackWidget.style.bottom = "".concat(progressBarHeight + defaultWidgetOffset, "px");
          }
        }
      });
    }
  }]);

  return ProgressBar;
}();

export default ProgressBar;